module.exports = __webpack_public_path__ + "resources/img/solution_game.7296820257b9410f486ef07036cb5c10.png";